import { messageUpdatePassword } from '@/event/account/dashboard/messageUpdatePassword'
import { showAlertUpdatePassword } from '@/event/account/dashboard/showAlertUpdatePassword'
import { messageAlert } from '@/event/alert/messageAlert'

export function toggleUpdatePassword() {
  showAlertUpdatePassword.value = !showAlertUpdatePassword.value
  messageUpdatePassword.value = messageAlert
}
